<template>
    <div>
        <h5>All Existing Attributes</h5>
        <div class="card">
            <div class="flex justify-content-between">
                <h6 class="mt-3">Filter Attributes:</h6>
                <Button v-if="authStore.hasPermission(UserPermission.WRITE_ASSESSMENT_ATTRIBUTES)" class="mb-3" label="Create an attribute" @click="dialogForm = true" />
            </div>
            <!-- filters -->
            <attribute-filters />
        </div>
        <!-- attribute table -->
        <attribute-table />
        <!-- create attribute form -->
        <attribute-form v-if="dialogForm" @hide-dialog="dialogForm = false" />
    </div>
</template>
<script setup>
import AttributeFilters from '../modules/AttributeFilters.vue';
import AttributeTable from '../modules/AttributeTable.vue';
import AttributeForm from '../modules/AttributeForm.vue';
import { ref, onMounted } from 'vue';
import { authStore, formulaStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';

const dialogForm = ref(false);

onMounted(() => {
    loadFormulas();
});

const loadFormulas = async () => {
    await formulaStore.fetchFormulas();
};
</script>
